import { call, put, select, take } from "redux-saga/effects";

import { MODAL_TYPES } from "../constants/modals";
import firebase from "../services/firebase";
import * as actions from "../constants/actions";
import * as actionTypes from "../constants/actionTypes";
import pushWithLng from "./pushWithLng";
import { getUserId, getEditorModel, getModelById, getLocaleLng } from "../selectors";

export function* createModel({ payload }) {
  const { values, resolve, reject } = payload;
  const { folderId } = values;
  const lng = yield select(getLocaleLng);
  const userId = yield select(getUserId);
  const model = yield select(getEditorModel);

  const { error } = yield call(firebase.model.create, {
    userId,
    folderId,
    ...model
  });

  if (error) {
    reject(error);
  } else {
    resolve();

    yield put(actions.fetchModels({ userId }));
    yield put(actions.closeModal());
    yield put(pushWithLng("/account", lng));
  }
}

export function* updateModel({ payload }) {
  const { id, params } = payload;
  const model = yield select(getModelById, id);

  const { error } = yield call(firebase.model.update, id, {
    ...model,
    ...params
  });

  if (error) {
    // TODO: handle error in UI
  } else {
    const userId = yield select(getUserId);
    const models = yield call(firebase.model.fetchAll, { userId });
    yield put(actions.setModels({ models }));
  }
}

export function* fetchModels() {
  const userId = yield select(getUserId);
  const models = yield call(firebase.model.fetchAll, { userId });

  yield put(actions.setModels({ models }));
}

export function* fetchModel({ payload }) {
  const { id } = payload;
  const model = yield call(firebase.model.fetch, { id });

  if (model) {
    yield put(actions.setModel({ id, model }));
  } else {
    yield put(actions.modelNotFound({ id }));
  }
}

export function* fetchModelExport({ payload }) {
  const model = yield call(firebase.model.fetch, { id: payload.token });

  if (model) {
    yield put(actions.setModel({ id: model.id, model }));
  } else {
    yield put(actions.modelNotFound({ id: payload.token }));
  }
}

export function* deleteModel({ payload }) {
  yield put(
    actions.openModal({
      modalType: MODAL_TYPES.DELETE_MODEL_CONFIRMATION
    })
  );

  const { type } = yield take([
    actionTypes.MODAL_CONFIRMED,
    actionTypes.MODAL_CLOSE
  ]);

  if (type !== actionTypes.MODAL_CONFIRMED) {
    return;
  }

  const { id } = payload;
  const { error } = yield call(firebase.model.destroy, { id });

  yield put(actions.closeModal());

  if (error) {
    // TODO: handle error in UI
  } else {
    yield put(actions.unsetModel({ id }));
  }
}



// WEBPACK FOOTER //
// ./src/sagas/models.js